// extracted by mini-css-extract-plugin
module.exports = {"divider":"CustomSplitter_divider","root":"CustomSplitter_root","panel":"CustomSplitter_panel"};